import Vue from 'vue'
import Vuex from 'vuex'
// root
import * as getters from './getters.js'
import { state, actions, mutations } from './root.js'
// modules
import system from './modules/system'

Vue.use(Vuex)

export default new Vuex.Store({
  state,
  mutations,
  actions,
  modules: {
    system
  },
  getters,

  strict: true
})
